var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "2 2 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3C19.5228 3 24 7.48092 24 13.0084C24 18.5359 19.5228 23.0168 14 23.0168C8.47715 23.0168 4 18.5359 4 13.0084C4 7.48092 8.47715 3 14 3Z",
    fill: "url(#paint0_linear_4286_9796)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2305 16.8652C21.7216 20.478 18.157 23.0167 14 23.0167C8.47715 23.0167 4 18.5358 4 13.0083C4 11.9677 4.15867 10.9643 4.45311 10.0208C5.95291 9.62135 7.55533 9.40527 9.22 9.40527C15.4956 9.40527 20.8863 12.4761 23.2305 16.8652Z",
    fill: "url(#paint1_radial_4286_9796)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4286_9796)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4705 7.11133C9.73046 7.11133 8.33594 8.50047 8.33594 10.2262V15.825C8.33594 17.5396 9.74337 18.9399 11.4705 18.9399H16.8875C18.6275 18.9399 20.0221 17.5507 20.0221 15.825V10.2262C20.0221 8.5116 18.6146 7.11133 16.8875 7.11133H11.4705ZM9.52093 15.825V10.2262C9.52093 9.15594 10.3839 8.29631 11.4705 8.29631H16.8875C17.9615 8.29631 18.8371 9.1674 18.8371 10.2262V15.825C18.8371 16.8953 17.9741 17.7549 16.8875 17.7549H11.4705C10.3965 17.7549 9.52093 16.8838 9.52093 15.825ZM11.0914 13.0724C11.0914 14.8107 12.478 16.2244 14.1943 16.2244C15.9107 16.2244 17.2973 14.8107 17.2973 13.0724C17.2973 11.3342 15.9107 9.92049 14.1943 9.92049C12.478 9.92049 11.0914 11.3342 11.0914 13.0724ZM16.1123 13.0724C16.1123 14.1613 15.251 15.0394 14.1943 15.0394C13.1376 15.0394 12.2763 14.1613 12.2763 13.0724C12.2763 11.9836 13.1376 11.1055 14.1943 11.1055C15.251 11.1055 16.1123 11.9836 16.1123 13.0724ZM18.006 9.88871C18.006 10.3024 17.677 10.6378 17.2712 10.6378C16.8654 10.6378 16.5364 10.3024 16.5364 9.88871C16.5364 9.47499 16.8654 9.1396 17.2712 9.1396C17.677 9.1396 18.006 9.47499 18.006 9.88871Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4286_9796",
    x: 0.335938,
    y: 0.111328,
    width: 27.6855,
    height: 27.8281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.136011 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4286_9796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4286_9796",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4286_9796",
    x1: 5.16694,
    y1: 4.05234,
    x2: 11.4827,
    y2: 28.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E60D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.142763,
    stopColor: "#913BAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761458,
    stopColor: "#D52D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26D4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4286_9796",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.82189 23.0167) rotate(23.9911) scale(16.6422 9.87323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17024,
    stopColor: "#FDBD61",
    stopOpacity: 0.975006
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454081,
    stopColor: "#F6804D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D5C",
    stopOpacity: 0.01
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e7f06cbdf7e4cb97fd288db13feb444a.svg";
export { ForwardRef as ReactComponent };